import { render } from "./Translations.vue?vue&type=template&id=8241b560"
import script from "./Translations.vue?vue&type=script&lang=js"
export * from "./Translations.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__